<div class="row g-0" style="border-bottom: 1px solid #CDCED5;">
    <div class="col-12">
      <div class="filter-title">
        <div class="title">
        <a href="javascript:void(0)" class="filter-text-color">Filter</a>   <a href="javascript:void(0)" class="ms-auto view-more d-none d-lg-block" (click)="clearAllFilter('Clear')">Clear all</a>
          <a href="javascript:void(0)" class="ms-auto view-more d-lg-none" (click)="closeFilter()">Close</a>
        </div>
      </div>
    </div>
  </div>
  <div class="row  g-0">
    <div class="col-12">
      <div class="accordion" id="accordionFilter">
        <div class="accordion-item" *ngFor="let item of filterName; let id=index">
          <h2 class="accordion-header d-flex" id="header{{id}}"><img class="me-2" [src]="item?.image">
            <a style="text-decoration: none;" class="accordion-button collapsed" [ngClass]="{'active' : item.key=='Usage'}"  data-bs-toggle="collapse"
            aria-expanded="false" data-bs-target="#collapseFilter{{id}}"  href="#collapseFilter{{id}}" aria-controls="collapseFilter{{id}}">
              {{item.key}} <span class="ms-auto d-lg-none">
                <ng-container *ngIf="item.key == 'State'">{{state}}</ng-container>
                <ng-container *ngIf="item.key == 'Models'">{{models}}</ng-container>
                <ng-container *ngIf="item.key == 'Cities'">{{cities}}</ng-container>
              </span>
          </a>
          </h2>
          <div id="collapseFilter{{id}}" class="accordion-collapse collapse" [ngClass]="{'show' : item.key=='Usage'}" aria-labelledby="header{{id}}"
            data-bs-parent="#accordionFilter">
            <div class="accordion-body">
              <div class="search-p-scroll mb-2" *ngIf="item.key != 'Budget'">
                <input type="search" placeholder="Search {{item.key}}" #id id="{{id}}"
                  class="form-control form-control-sm search-control"
                   (input)="searchFilter(item,id.value)">
              </div>
              <div class="search-p-scroll mb-2" *ngIf="item.key == 'Budget'">
                <div class="highchart-wrapper">
                  <div class="ngx-slider-wrapper">
                    <ngx-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="ssoptions"  (mouseup)="sliderEvent()"></ngx-slider>
                    <div class="row mt-1">
                      <div class="col-6">
                        <label class="filter-label">Min Price</label>
                        <input type="text" [value]="minValue" class="form-control form-control-sm" maxlength="10" minlength="1" (focusout)="onbudegetChange($event,'price_from')" (keypress)="onlyNumberKey($event)"/>
                      </div>
                      <div class="col-6">
                        <label class="filter-label">Max Price</label>
                        <input type="text" [value]="maxValue" class="form-control form-control-sm" maxlength="10" minlength="1" (focusout)="onbudegetChange($event,'price_to')" (keypress)="onlyNumberKey($event)"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ltr-filter-scroll ps-1" *ngIf="item.key != 'Budget'">
                <div class="form-check" *ngFor="let row of item.data; let i=index">
                  <input class="form-check-input" type="checkbox" value="" (click)="onCheckedClick(row.key,item.key)"
                    [checked]="row.checked">
                  <label class="form-check-label" for="flexCheckChecked" (click)="onCheckedClick(row.key,item.key)">
                    {{row.key}}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sticky-filter d-flex gap-3 d-lg-none">
        <a href="javascript:void(0)" class="btn btn-outline-primary btn-grad-outline-primary btn-brand text-uppercase" (click)="clearAllFilter('Mobile')">Clear Filters</a>
        <a href="javascript:void(0)" class="btn btn-primary btn-grad-primary btn-brand text-uppercase" (click)="closeFilter()">Show  {{searchTotal}} results</a>
      </div>
    </div>
  </div>


